<template>
  <button
    :data-external="`signing-page-bank-id-option-${option.name}-button`"
    :class="['eid-option-container', { disabled: disableClick, selected }]"
    @click="select"
  >
    <EIdIcon class="eid-option-icon" :type="(option.icon as EIdIconType)" />
    <span class="name">
      {{ option.name }}
    </span>
  </button>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import type { Id } from '../types/eid';
import { EIdIconType } from '../types/enums/eid-icon-type';
import EIdIcon from './EIdIcon.vue';

export default defineComponent({
  components: {
    EIdIcon,
  },
  props: {
    option: {
      type: Object as PropType<Id>,
      required: true,
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select'],
  setup(props, { emit }) {
    const select = () => {
      if (!props.disableClick) {
        emit('select', props.option);
      }
    };

    return {
      select,
      EIdIconType,
    };
  },
});
</script>

<style lang="scss" scoped>
.eid-option-container {
  padding: var(--spacing-50);
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 0;
  background: transparent;
  width: 100%;
  text-align: left;
  border-radius: var(--radius-small);

  .eid-option-icon {
    margin-right: var(--spacing-50);
  }

  &:hover:not(.disabled) {
    background-color: var(--gray-96);
  }

  &:focus:not(.disabled) {
    background-color: var(--gray-94);
  }

  &.selected {
    background: var(--gray-94);
  }
}
</style>
